// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import {
    ProductDetailsCanScrollNextParameter,
    ProductDetailsCanScrollPrevParameter,
} from "@store/Framework/Store/Bunzl/Pages/ProductDetails/ProductDetailsTypes";
import { Draft } from "immer";

type ProductDetailsState = ApplicationState["bunzl"]["pages"]["productDetails"];

const initialState: ProductDetailsState = {
    canScrollNext: false,
    canScrollPrev: false,
};

const actions = {
    "Store/Pages/ProductDetails/CanScrollNext": (
        draft: Draft<ProductDetailsState>,
        action: { parameter: ProductDetailsCanScrollNextParameter },
    ) => {
        draft.canScrollNext = action.parameter;
    },
    "Store/Pages/ProductDetails/CanScrollPrev": (
        draft: Draft<ProductDetailsState>,
        action: { parameter: ProductDetailsCanScrollPrevParameter },
    ) => {
        draft.canScrollPrev = action.parameter;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlPagesProductDetailsActions = BunzlActionUnion<typeof actions>;
export default reducer;
